import { INSPECTION_CHECKLIST_STEPS } from "../inspection-form.catalog";
import type { InspectionChecklistStepWrapperProps } from "./checklistStep.props";
import InspectionChecklistStep from "./InspectionChecklistStep";

const InspectionBeachConditionStep = (props: InspectionChecklistStepWrapperProps) => (
  <InspectionChecklistStep step={INSPECTION_CHECKLIST_STEPS.beachCondition} {...props} />
);

export default InspectionBeachConditionStep;
